import { PlusOutlined } from '@ant-design/icons';
import { message } from '@/components/Message';
import React, { useState } from 'react';
import { Coupon, grantCouponUser } from '@/models/coupon';
import { User } from '@/models/user';
import CouponModalSelector from '../../pages/Marketing/Coupon/CouponModalSelector';
import Modal from '../Modal';
import PosButton from '../PosButton';
import UserName from '../User/Name';

export type Props = {
  user: User;
  onCouponUserChange: () => void;
};

export default ({ user, onCouponUserChange }: Props) => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<Coupon>();
  return (
    <>
      <CouponModalSelector
        alert={{ message: `经营端发券不受券领用规则约束`, type: 'warning', showIcon: true }}
        open={selectorOpen}
        value={selectedCoupon}
        onCancel={() => {
          setSelectorOpen(false);
        }}
        onChange={value => {
          setSelectedCoupon(value);
          setSelectorOpen(false);
          Modal.confirm({
            title: '发券二次确认',
            content: (
              <>
                将向当前用户
                <b className="emphasize red">
                  <UserName user={user} />
                </b>
                发放优惠券
                <b className="emphasize red">{value.name}</b>，请确认该操作
              </>
            ),
            onOk: async () => {
              await grantCouponUser({ username: user.username, couponId: value.id });
              message.success(`操作成功`);
              onCouponUserChange?.();
              setSelectedCoupon(undefined);
            },
            onCancel: () => {
              setSelectedCoupon(undefined);
            },
          });
        }}
      />
      {/* </Modal> */}
      <PosButton
        color="primary"
        variant="outlined"
        icon={<PlusOutlined />}
        onClick={() => {
          setSelectorOpen(true);
        }}>
        发放优惠券
      </PosButton>
    </>
  );
};
